import { InjectionToken } from '@angular/core';
import { RequestsPort } from './requests.port';

export const REQUESTS_PORT = new InjectionToken<RequestsPort>('REQUESTS_PORT');
